// src/components/UserHeader.jsx
import React, { useState } from 'react';
import Modal from './Modal';
import UserProfileView from './UserProfileView';

const UserHeader = ({ user = {}, onLogout, bluesky, bookmarkService }) => {
  const [showProfile, setShowProfile] = useState(false);

  const getDisplayLetter = () => {
	if (user?.displayName) return user.displayName.charAt(0).toUpperCase();
	if (user?.handle) return user.handle.charAt(0).toUpperCase();
	return '?';
  };

  return (
	<>
	  <button
		className="user-avatar-button"
		onClick={() => setShowProfile(true)}
		aria-label="View profile"
	  >
		{user?.avatar ? (
		  <img
			src={user.avatar}
			alt={`${user?.displayName || user?.handle || 'User'}'s avatar`}
			className="user-avatar"
		  />
		) : (
		  <div className="user-avatar-placeholder">
			{getDisplayLetter()}
		  </div>
		)}
	  </button>

	  {showProfile && user?.did && (
		<Modal
		  isOpen={showProfile}
		  onClose={() => setShowProfile(false)}
		  fullWidth
		>
		  <UserProfileView
			user={user}
			onLogout={() => {
			  onLogout();
			  setShowProfile(false);
			}}
			onClose={() => setShowProfile(false)}
			bluesky={bluesky}
			bookmarkService={bookmarkService}
		  />
		</Modal>
	  )}
	</>
  );
};

export default UserHeader;